import Global from './globals/avista-global'
import JobApplications from './components/job-application'

window.almComplete = function (alm) {
  const _body = Global.cacheBody()
  JobApplications.init(_body, Global)
};



// WEBPACK FOOTER //
// ./library/src/js/avista-job-applications.js